import type {
	CompositeFilterDescriptor,
	SortDescriptor,
} from "@tql/ui-components-react/kendo/data-query";
import type { GridSortChangeEvent } from "@tql/ui-components-react/kendo/grid";
import { useCallback, useState } from "react";

export const useRoutingGuideGridState = () => {
	const [filter, setFilter] = useState<CompositeFilterDescriptor | undefined>(
		undefined,
	);

	const [sort, setSort] = useState<SortDescriptor[]>([
		{ field: "id", dir: "desc" },
	]);

	const handleFilterChange = useCallback(
		(event: { filter: CompositeFilterDescriptor | null }) => {
			setFilter(event.filter ?? undefined);
		},
		[],
	);

	const handleSortChange = useCallback((event: GridSortChangeEvent) => {
		setSort(event.sort);
	}, []);

	return {
		filter,
		handleFilterChange,
		sort,
		handleSortChange,
	};
};
